<template>
<div>
    Init
</div>
</template>
<script>
export default ({
    mounted() {
        if(location.search.indexOf("token") > -1) {
            var token = location.search.substr(7).trim();
            console.log("EMIT TOKEN")
            this.$emit('setToken', token);
        }
    },
})
</script>
